import {createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {TAB_ENUM, productType} from './Constant';
import {} from './SelfCareSlice';
import {setAuthenticationName} from '../../../utilities/authentication/authenticationSlice';

export const getSelfCareData = createAsyncThunk('selfCarePage/getSelfCareData', async (blockId, thunkAPI) => {
  try {
    const selfCareData = await ProviderManager.getProviderData('selfCareData', {});
    const results = selfCareData.Body;
    return results;
  } catch (err) {
    return;
  }
});

export const getTrackerItems = createAsyncThunk('selfCarePage/getTrackerItems', async (data, thunkAPI) => {
  let orderedTrackerItems = [];
  let numOfItems = 0;
  let error = false;
  let res = null;

  try {
    const providerData = await ProviderManager.getProviderData('trackerData', {});
    res = providerData?.Body;
    if (res.trackerItems.length > 0) {
      let baseItems = res.trackerItems;
      numOfItems = baseItems.length;
      orderedTrackerItems = [...baseItems];
    } else {
      error = true;
    }
  } catch (err) {
    error = true;
  }
  return {
    orderedTrackerItems: orderedTrackerItems,
    numOfItems: numOfItems,
    error: error,
    shouldShowPopup: res?.showPopupOnTrackerInit,
    popupType: res?.trackerInitPopupReason,
  };
});

export const getMyInvoices = createAsyncThunk('selfCarePage/getMyInvoices', async (data, thunkAPI) => {
  try {
    const providerData = await ProviderManager.getProviderData('invoiceData', {});
    const res = providerData?.Body;
    if (res?.error) {
      return {invoices: [], error: true};
    }

    let invoices = res ? res.invoices : [];
    return {invoices: invoices, error: false};
  } catch (error) {
    //case when self Care Data fail
    return {invoices: [], error: true};
  }
});

export const getOnboardingSubs = createAsyncThunk('selfCarePage/getOnboardingSubs', async (data, thunkAPI) => {
  let subList = [];
  try {
    const state = await thunkAPI.getState();
    if (state.authentication.loginData?.userDetails?.contactNumber) {
      let cellular;
      if (
        state.selfcarePage.subscribersByProduct != null &&
        state.selfcarePage.subscribersByProduct != [] &&
        state.selfcarePage.subscribersByProduct?.Cellular
      ) {
        cellular = state.selfcarePage.subscribersByProduct.Cellular;
      } else {
        const subByProduct = await thunkAPI.dispatch(Onboarding());
        cellular = subByProduct.payload?.subscribersByProduct.Cellular;
      }
      subList = cellular.map((product) => product.productSubscriberNo);
    }
  } catch (err) {}
  return subList;
});

export const Onboarding = createAsyncThunk('selfCarePage/Onboarding', async (data, thunkAPI) => {
  try {
    const OnboardingData = await ProviderManager.getProviderData('OnboardingData', {});
    const state = await thunkAPI.getState();
    const loginData = state.authentication.loginData;
    const existingProducts = state.selfcarePage.subscribersByProduct;
    var subscribersByProduct = OnboardingData?.Body?.subscribersByProduct;

    const cellular = subscribersByProduct[TAB_ENUM.Cellular];
    if (cellular) {
      subscribersByProduct[TAB_ENUM.Abroad] = subscribersByProduct[TAB_ENUM.Cellular].map((p) => ({...p}));
    }

    if (subscribersByProduct) {
      Object.keys(subscribersByProduct).forEach((productType, index) => {
        subscribersByProduct[productType] = subscribersByProduct[productType].map((product, productIndex) => {
          if (product.productSubscriberNo == loginData?.userDetails?.contactNumber) {
            product.productFirstName = loginData?.userDetails?.firstName;
            product.productLastName = loginData?.userDetails?.lastName;
          }
          if (existingProducts != [] && existingProducts?.[TAB_ENUM.Abroad]) {
            const matchingProduct = existingProducts[TAB_ENUM.Abroad]?.find((p) => p.productSubscriberNo === product.productSubscriberNo);
            if (matchingProduct?.customerAbroadPackages?.length > 0) {
              product.newAbroadPackage = matchingProduct.newAbroadPackage;
              if (matchingProduct.newAbroadPackage) {
                product.abroadAddons = matchingProduct.abroadAddons;
              }
            }
          }
          product.productType = productType;
          return product;
        });
      });

      const internetWorldProducts = internetProductsMerge(subscribersByProduct);
      if (internetWorldProducts.length > 0) {
        subscribersByProduct[productType.Internet] = internetWorldProducts;
      }
    }

    return OnboardingData?.Body;
  } catch (err) {
    return;
  }
});

export const goToPage = createAsyncThunk('selfCarePage/saveToHistory', async (data, thunkAPI) => {
  thunkAPI.dispatch({type: 'selfcarePage/saveToHistory'});
});

// export const getBenefit = createAsyncThunk('UpdateCustomerDetails/GetBenefit', async (blockId, thunkAPI) => {
//   try {
//     const result = await ProviderManager.getProviderData('benefitData', [blockId]);
//     return result?.Body;
//   } catch (error) {
//     return {
//       error: true,
//       reason: error,
//     };
//   }
// });

export function productsAndServicesResponse(productsAndServicesDetails) {
  const response = {
    Internet: [],
    TV: [],
    Cellular: [],
    Energy: [],
  };

  if (!productsAndServicesDetails) {
    return response;
  }

  // Assign base products
  response.Cellular = productsAndServicesDetails.Cellular ?? [];
  response.Energy = productsAndServicesDetails.Energy ?? [];
  response.TV = productsAndServicesDetails.TV ?? [];
  response.Internet = internetProductsMerge(productsAndServicesDetails);

  // Helper function to add bundle item without mutation
  const addInternetBundle = (source, additionalProps = {}) => {
    if (source) {
      response.Internet.push({
        ...source,
        isBundle: true,
        ...additionalProps,
      });
    }
  };

  const addTvBundle = (source) => {
    if (source) {
      response.TV.push({
        ...source,
        isBundle: true,
      });
    }
  };

  // Process bundle items
  productsAndServicesDetails.Bundle?.forEach((bundleItem) => {
    // Add internet items from bundle
    addInternetBundle(bundleItem.internetItem ?? bundleItem.internetIsp, {mapaItem: bundleItem.mapaItem});
    // Add TV items from bundle
    addTvBundle(bundleItem.tvItem);
  });

  return response;
}

export function internetProductsMerge(products) {
  let internetWorldProducts = [];

  const addProducts = (productType) => {
    if (products[productType]?.length > 0) {
      internetWorldProducts.push(
        ...products[productType].map((item) => {
          item['internetProductType'] = productType;
          return item;
        }),
      );
    }
  };

  addProducts(productType.Internet);
  addProducts(productType.InternetIsp);
  addProducts(productType.InternetInfra);
  addProducts(productType.Mapa);

  return internetWorldProducts;
}
